<template>
  <label class="checkbox-inline">
    <input type="checkbox" 
      :checked="hasValue"
      :disabled="isDisabled"
      @click="setFilter"
    >
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },
    filters: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    hasMultipleValues: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isDisabled: false,
    }
  },

  computed: {
    hasFilter() {
      return this.name in this.filters && this.filters[this.name] != '';
    },

    hasValue() {
      if(!this.hasFilter) {
        return false
      }

      let values = this.filters[this.name].split(',')

      return values.indexOf(this.id) >= 0
    },
  },

  methods: {
    setFilter(event) {
      let value = ''

      if (!this.hasFilter || (!this.hasMultipleValues && !this.hasValue)) {
        value = this.id
      } else if (this.hasMultipleValues) {
        value = this.toggleValues()
      }

      this.isDisabled = ! this.callback(value, this.name)
    },

    toggleValues() {
      let parameter = this.filters[this.name]

      if(!parameter) {
        return ''
      }

      let values = parameter.split(',')
      let index = values.indexOf(this.id)

      if(index >= 0) {
        values.splice(index, 1)
      } else {
        values.push(this.id)
      }

      return values.join(',')
    }
  }
}
</script>